<template>
  <div class="text-courseware-page">
    <!-- 顶部Banner -->
    <Banner />
    <div class="content-wrapper">
      <div class="left-list">
        <!-- 分类导航 -->
        <nav-filter />
        <!-- 面包屑 -->
        <div class="breadcrumb-bar">
          <button
            class="breadcrumb-back"
            @click="
              $router && $router.back ? $router.back() : window.history.back()
            "
          >
            返回
          </button>
          <span class="breadcrumb-link">万知学习</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">{{ teacherInfo.position }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">{{ teacherInfo.name }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">{{ type === 3 ? '付费' : '免费' }}视频课件列表</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-current">{{ type === 3 ? '付费' : '免费' }}视频详情</span>
        </div>

        <!-- 课件详情 -->
        <div class="courseware-detail">
          <div class="courseware-header">
            <h1 class="courseware-title">
              《{{ data.title || '--' }}》
            </h1>
            <div class="courseware-meta">
              <div class="meta-stats">
                <span class="meta-item"
                  ><img src="@/assets/images/eye.png" alt="阅读" /> 阅读：<span
                    class="count"
                    >{{ data.clickcount || 0 }}</span
                  ></span
                >
                <span class="meta-item"
                  ><img src="@/assets/images/ly.png" alt="留言" /> 留言：<span
                    class="count"
                    >{{ data.liuyancount || 0 }}</span
                  ></span
                >
                <span class="meta-item"
                  ><img src="@/assets/images/time.png" alt="时间" />
                  {{ data.inputtime || '-' }}</span
                >
              </div>
              <div class="meta-actions">
                <button class="btn-report" @click="downloadVideo">下载视频</button>
              </div>
            </div>
          </div>

          <div class="courseware-content">
            <!-- 视频播放区域 -->
            <div class="video-player">
              <img
                v-if="data.fengmian"
                :src="picUrl + data.fengmian"
                alt="视频封面"
                class="video-poster"
                v-show="!videoPlayer.isPlaying"
              />
              <video
                ref="mainVideo"
                :src="RegExp('vod', 'i').test(data.fileurl)?data.fileurl:picUrl + data.fileurl"
                controls
                class="main-video"
                @timeupdate="updateProgress"
                @loadedmetadata="updateProgress"
                @ended="videoPlayer.isPlaying = false"
              ></video>
              <div class="video-controls">
                <button class="play-btn" @click="togglePlay">
                  {{ videoPlayer.isPlaying ? '⏸' : '▶' }}
                </button>
                <div
                  class="progress-bar"
                  ref="progressBar"
                  @click="seekVideo"
                >
                  <div
                    class="progress-inner"
                    :style="{ width: videoPlayer.progress + '%' }"
                  ></div>
                </div>
                <span class="time-display"
                  >{{ formatTime(videoPlayer.currentTime) }} /
                  {{ formatTime(videoPlayer.duration) }}</span
                >
                <button class="fullscreen-btn" @click="toggleFullscreen">⛶</button>
              </div>
            </div>

            <!-- 操作提示信息 -->
            <div class="video-tips">
              视频播放介绍：右侧设置面板中可设置视频播放尺寸、颜色、阴影/滤镜；只有手机页面可设置视频透明度；页中页面后，轻轻拖拽在顶部下方，可以缩短顶栏高度，拖动可在右侧操作面板中设置
            </div>

            <!-- 操作按钮模块 -->
            <div class="operation-section">
              <div class="operation-list">
                <div class="operation-item" :class="{ 'active': operationStats.isLiked }" @click="handleLike">
                  <img :src="operationStats.isLiked ? require('@/assets/images/dz-active.png') : require('@/assets/images/dz.png')" alt="点赞" class="operation-icon">
                  <span class="operation-text">点赞</span>
                  <span class="operation-count">{{operationStats.likeNum}}</span>
                </div>
                <div class="operation-item" :class="{ 'active': operationStats.isCollected }" @click="handleCollect">
                  <img :src="operationStats.isCollected ? require('@/assets/images/sc-active.png') : require('@/assets/images/sc.png')" alt="收藏" class="operation-icon">
                  <span class="operation-text">收藏</span>
                  <span class="operation-count">{{operationStats.collectNum}}</span>
                </div>
                <div class="operation-item" @click="showRatingDialog = true">
                  <img src="@/assets/images/pf.png" alt="评分" class="operation-icon">
                  <span class="operation-text">评分</span>
                  <span class="operation-count">{{operationStats.averageScore}}</span>
                </div>
                <div class="operation-item">
                  <img src="@/assets/images/lw.png" alt="礼" class="operation-icon">
                  <span class="operation-text">礼</span>
                  <span class="operation-count">99+</span>
                </div>
                <div class="operation-item" @click="showGiftDialog = true">
                  <img src="@/assets/images/hd.png" alt="花" class="operation-icon">
                  <span class="operation-text">花</span>
                  <span class="operation-count">{{operationStats.flowerNum}}</span>
                </div>
                <div class="operation-item" @click="handleShare">
                  <img src="@/assets/images/fx.png" alt="分享" class="operation-icon">
                  <span class="operation-text">分享</span>
                  <span class="operation-count">15</span>
                </div>
                <div class="operation-item" @click="handleShare">
                  <img src="@/assets/images/cc.png" alt="橱窗" class="operation-icon">
                  <span class="operation-text">橱窗</span>
                </div>
                <div class="operation-item">
                  <img src="@/assets/images/more.png" alt="更多" class="operation-icon">
                  <span class="operation-text">更多</span>
                </div>
              </div>
            </div>
          </div>

          <div class="comment-section">
            <div class="comment-input">
              <textarea
                v-model="message"
                placeholder="请输入留言内容"
                class="comment-textarea"
              ></textarea>
              <button class="btn-publish" @click="leaveMessage">发布</button>
            </div>

            <div class="comment-list">
              <div
                class="comment-item"
                v-for="(item, index) in travleList.lists"
                :key="index"
              >
                <div class="avatar">
                  <img :src="picUrl + item.avatar" alt="用户头像" />
                </div>
                <div class="comment-content">
                  <div class="nickname">{{ item.nickname }}</div>
                  <div class="text">{{ item.content }}</div>
                  <div class="comment-time">
                    <img src="@/assets/images/time.png" alt="时间" />
                    <span class="time">{{ item.inputtime }}</span>
                    <span class="reply" @click="openHfLiuyan(index, true)">回复</span>
                  </div>
                  <!-- 回复区域 -->
                  <div class="reply-section" v-if="indexes[index]">
                    <div class="reply-input">
                      <textarea
                        v-model="huifuMessage"
                        placeholder="请输入回复内容"
                        class="reply-textarea"
                      ></textarea>
                      <button
                        class="btn-reply"
                        @click="postReplyM(item.id)"
                      >
                        回复
                      </button>
                    </div>
                  </div>
                  <!-- 回复列表 -->
                  <div class="reply-list" v-if="item.reply && item.reply.length">
                    <div
                      class="reply-item"
                      v-for="(reply, replyIndex) in item.reply"
                      :key="replyIndex"
                    >
                      <div class="reply-avatar">
                        <img :src="picUrl + reply.touxiang" alt="回复者头像" />
                      </div>
                      <div class="reply-content">
                        <div class="reply-nickname">{{ reply.nickname }}</div>
                        <div class="reply-text">{{ reply.content }}</div>
                        <div class="reply-time">
                          <img src="@/assets/images/time.png" alt="时间" />
                          <span>{{ reply.inputtime }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 分页 -->
            <el-pagination
              v-if="travleList.total > 0"
              background
              layout="prev, pager, next"
              :total="travleList.total"
              :page-size="10"
              :current-page="page"
              @current-change="handlePageChange"
              class="pagination-bar"
            />
          </div>
        </div>
      </div>

      <div class="right-news">
        <!-- <ad-sidebar /> -->
        <v-right :marketBannerSmall="marketBannerSmall" :marTop="false"></v-right>
      </div>
    </div>

    <!-- 送礼物弹窗 -->
    <el-dialog
      :visible.sync="showGiftDialog"
      :show-close="true"
      width="800px"
      custom-class="gift-dialog"
      center
      @open="getGiftList"
    >
      <div class="gift-dialog-content">
        <div class="dialog-left">
          <div class="teacher-profile">
            <img :src="teacherInfo.zhaopian ? picUrl + teacherInfo.zhaopian : require('@/assets/images/teacher.png')" alt="教师头像" class="teacher-avatar">
            <h3 class="teacher-name">{{teacherInfo.name}}老师</h3>
            <p class="teacher-title">{{teacherInfo.position}}</p>
            <p class="teacher-location">{{teacherInfo.location}}</p>
            <p class="teacher-rating">
              <span class="rating-label">上次评级：</span>
              <span class="rating-value">{{teacherInfo.rating}}</span>
            </p>
          </div>
        </div>
        <div class="dialog-right">
          <div class="gift-list">
            <template v-if="!giftLoading && giftList.length > 0">
              <div
                v-for="(gift, index) in giftList"
                :key="index"
                class="gift-item"
                :class="{ 'active': selectedGift === index }"
                @click="selectGift(index)"
              >
                <img :src="gift.image" :alt="gift.name" class="gift-image">
                <div class="gift-name">{{gift.name}}</div>
                <div class="gift-price">¥{{gift.price}}</div>
              </div>
            </template>
            <div v-else-if="giftLoading" class="loading-container">
              <div class="loading-spinner"></div>
              <p>正在加载礼物列表...</p>
            </div>
            <div v-else class="empty-state">
              <img src="@/assets/images/empty.png" alt="暂无礼物" class="empty-icon">
              <p class="empty-text">暂无可用礼物</p>
            </div>
          </div>
        </div>
      </div>
      <div class="gift-footer">
        <div class="footer-left">
          <el-radio v-model="agreeProtocol">
            我已阅读并同意<span class="protocol-link" @click.stop="openGiftProtocol">《赠送协议》</span>
          </el-radio>
        </div>
        <div class="footer-center">
          <div class="quantity-control">
            <span class="quantity-label">数量：</span>
            <button @click="decreaseQuantity" class="quantity-btn">-</button>
            <input type="text" v-model="giftQuantity" class="quantity-input" readonly>
            <button @click="increaseQuantity" class="quantity-btn">+</button>
          </div>
          <div class="total-price">
            总计：<span class="price-value">¥{{totalPrice}}</span>
          </div>
        </div>
        <div class="footer-right">
          <el-button @click="showGiftDialog = false">取消</el-button>
          <el-button type="primary" @click="sendGift" :disabled="!agreeProtocol">确认送礼</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 赠送协议弹窗 -->
    <protocol-dialog
      :visible.sync="showProtocolDialog"
      title="赠送协议"
      confirm-text="我已知晓"
    />

    <!-- 支付二维码弹窗 -->
    <el-dialog
      :visible.sync="showPaymentDialog"
      :show-close="false"
      width="400px"
      custom-class="payment-dialog"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="payment-content">
        <h3 class="payment-title">请使用微信扫码支付</h3>
        <div id="payment-qrcode" class="qrcode-container"></div>
        <p class="payment-tip">请使用微信扫描二维码完成支付</p>
        <div class="payment-footer">
          <el-button type="primary" @click="handlePaymentDialogClose">关闭</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 支付确认弹窗 -->
    <el-dialog
      :visible.sync="showPaymentConfirm"
      width="400px"
      custom-class="payment-confirm-dialog"
      center
    >
      <div class="confirm-content">
        <p>是否确认关闭支付窗口？</p>
        <p class="confirm-tip">请确认是否已完成支付</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPaymentConfirm = false">取消</el-button>
        <el-button type="primary" @click="confirmClosePayment">确认关闭</el-button>
      </span>
    </el-dialog>
     <!-- 评分弹窗 -->
     <el-dialog
      :visible.sync="showRatingDialog"
      width="300px"
      custom-class="rating-dialog"
      center
    >
      <div class="rating-content">
        <h3 class="rating-title">教师评分</h3>
        <div class="rating-stars">
          <el-rate
            v-model="ratingValue"
            :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
            :texts="['极差', '较差', '还行', '推荐', '力荐']"
            show-text
          ></el-rate>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showRatingDialog = false">取消</el-button>
        <el-button type="primary" @click="submitRating">确定</el-button>
      </div>
    </el-dialog>

    <!-- 分享弹窗组件 -->
    <share-dialog
      :visible="showShareDialog"
      :share-data="shareDialogData"
      @close="handleShareClose"
      @share-success="handleShareSuccess"
    />
  </div>
</template>

<script>
import Banner from '@/components/common/Banner.vue'
// import AdSidebar from '@/components/common/AdSidebar'
import vRight from '@/components/education/Right2'
import NavFilter from '@/components/teacher/NavFilter.vue'
import ProtocolDialog from '@/components/common/ProtocolDialog'
import ShareDialog from '@/components/common/ShareDialog.vue'
import sign from '@/auth/sign'
import url from '@/axios/url'
import { getKejianDetail, getKejianMessL, getPostMessage, getPostReplyM, getEduFlowerList, sendFlower, updatePayStatus, getEduDetails, getEduLike, getEduCollect, getEduFlowerNum, getEduAverageNum, getEduCollectNum, getEduLikeNum, getEduRating } from '@/axios/education'
import Qs from 'qs'
import QRCode from 'qrcodejs2'

export default {
  name: 'VideoCoursewareDetail',
  components: {
    Banner,
    // AdSidebar,
    vRight,
    NavFilter,
    ProtocolDialog,
    ShareDialog
  },
  data () {
    return {
      page: 1,
      picUrl: url.picUrl,
      appid: 'wzwebapp',
      id: parseInt(this.$route.query.id),
      type: parseInt(this.$route.query.type) || 2, // 默认视频课件类型
      data: {},
      message: '',
      huifuMessage: '',
      indexes: [],
      travleList: {},
      operationStats: {
        flowerNum: '0', // 花数量
        averageScore: '0', // 评分
        collectNum: '0', // 收藏数量
        likeNum: '0', // 点赞数量
        isLiked: false, // 添加点赞状态
        isCollected: false // 添加收藏状态
      },
      videoPlayer: {
        isPlaying: false,
        currentTime: 0,
        duration: 0,
        progress: 0
      },
      showGiftDialog: false,
      giftList: [],
      selectedGift: null,
      giftQuantity: 1,
      totalPrice: 0,
      giftLoading: false,
      agreeProtocol: false,
      showProtocolDialog: false,
      showPaymentDialog: false,
      paymentQrCode: '',
      showPaymentConfirm: false,
      paymentTimer: null,
      orderNumber: null,
      teacherInfo: {
        name: '',
        position: '',
        rating: '',
        zhaopian: '',
        location: ''
      },
      showRatingDialog: false,
      ratingValue: 0,
      showShareDialog: false
    }
  },
  computed: {
    marketBannerSmall () {
      return this.$store.getters.travleBanner.sbanner
    },
    // 分享弹窗数据
    shareDialogData () {
      return {
        title: this.data.title || '',
        teacherName: this.teacherInfo.name || '',
        teacherId: this.data.teacher_id || null,
        coverImage: this.data.fengmian || '',
        picUrl: this.picUrl,
        type: this.type,
        appid: this.appid,
        url: window.location.href
      }
    }
  },
  created () {
    this.getData()
    this.getLists()
  },
  methods: {
    openGiftProtocol () {
      this.showProtocolDialog = true
    },
    async submitRating () {
      if (this.ratingValue === 0) {
        this.$message.warning('请选择评分')
        return
      }
      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.data.teacher_id,
        score: this.ratingValue
      }
      const signO = sign(params)
      params.sign = signO

      try {
        const res = await getEduRating(params)
        if (res.data && res.data.code === 200) {
          this.$message.success('评分成功')
          this.showRatingDialog = false
          this.getOperationStats()
        }
      } catch (error) {
        console.error('评分操作失败:', error)
        this.$message.error('操作失败，请稍后重试')
      }
    },
    getData () {
      const oneParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.id,
        type: this.type
      }
      const signO = sign(oneParams)
      oneParams.sign = signO
      getKejianDetail(oneParams).then(res => {
        if (res.data.code === 202) {
          this.$message({ type: 'warning', message: '请先登录' })
        } else if (res.data.code === 201 || res.data.code === 401) {
          this.$message({ type: 'error', message: res.data.msg })
        } else if (res.data.code === 200) {
          this.data = res.data.data
          // 获取教师信息
          this.getTeacherInfo()
          // 获取操作统计数据
          this.getOperationStats()
        }
      })
    },
    getTeacherInfo () {
      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.data.teacher_id,
        type: 3
      }
      const signO = sign(params)
      params.sign = signO
      getEduDetails(params).then(res => {
        if (res.data.code === 200) {
          const data = res.data.data
          this.teacherInfo = {
            name: data.realname || '',
            position: data.zhiwu || '',
            rating: data.pingji || '',
            location: data.city && data.position ? `${data.city}-${data.position}` : '',
            zhaopian: data.zhaopian || ''
          }
        }
      })
    },
    getLists () {
      const oneParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        page: this.page,
        id: this.id
      }
      const signO = sign(oneParams)
      oneParams.sign = signO
      getKejianMessL(oneParams).then(res => {
        if (res.data.msg === '请求成功') {
          this.travleList = res.data.data
          this.indexes = new Array(res.data.data.lists.length).fill(false)
        }
      })
    },
    leaveMessage () {
      if (!this.message.trim()) {
        this.$message({ type: 'warning', message: '请输入留言内容' })
        return
      }
      this.postMessage()
    },
    postMessage () {
      const oneParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.id,
        msg: this.message
      }
      const signO = sign(oneParams)
      oneParams.sign = signO
      const data = Qs.stringify(oneParams, { allowDots: true })
      getPostMessage(data).then(res => {
        this.$message({ type: 'success', message: res.data.msg })
        this.message = ''
        this.getLists()
      })
    },
    postReplyM (messageId) {
      if (!this.huifuMessage.trim()) {
        this.$message({ type: 'warning', message: '请输入回复内容' })
        return
      }
      const oneParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.id,
        message_id: messageId,
        msg: this.huifuMessage
      }
      const signO = sign(oneParams)
      oneParams.sign = signO
      const data = Qs.stringify(oneParams, { allowDots: true })
      getPostReplyM(data).then(res => {
        this.$message({ type: 'info', message: res.data.msg })
        this.huifuMessage = ''
        this.getLists()
      })
    },
    openHfLiuyan (index, flag) {
      this.$set(this.indexes, index, flag)
    },
    handlePageChange (page) {
      this.page = page
      this.getLists()
    },
    // 视频播放控制
    togglePlay () {
      const video = this.$refs.mainVideo
      if (video.paused) {
        video.play()
        this.videoPlayer.isPlaying = true
      } else {
        video.pause()
        this.videoPlayer.isPlaying = false
      }
    },
    updateProgress () {
      const video = this.$refs.mainVideo
      this.videoPlayer.currentTime = video.currentTime
      this.videoPlayer.duration = video.duration
      this.videoPlayer.progress = (video.currentTime / video.duration) * 100
    },
    seekVideo (event) {
      const video = this.$refs.mainVideo
      const progressBar = this.$refs.progressBar
      const rect = progressBar.getBoundingClientRect()
      const pos = (event.clientX - rect.left) / rect.width
      video.currentTime = pos * video.duration
    },
    toggleFullscreen () {
      const video = this.$refs.mainVideo
      if (!document.fullscreenElement) {
        video.requestFullscreen()
      } else {
        document.exitFullscreen()
      }
    },
    formatTime (time) {
      const minutes = Math.floor(time / 60)
      const seconds = Math.floor(time % 60)
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
    downloadVideo () {
      if (!this.data.fileurl) {
        this.$message.warning('视频地址不存在')
        return
      }

      const videoUrl = /vod/i.test(this.data.fileurl)
        ? this.data.fileurl
        : this.picUrl + this.data.fileurl

      // 显示加载提示
      const loading = this.$loading({
        lock: true,
        text: '正在准备下载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      // 使用 fetch 下载视频
      fetch(videoUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error('视频下载失败')
          }
          return response.blob()
        })
        .then(blob => {
          // 创建下载链接
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = this.data.title ? `${this.data.title}.mp4` : '视频课件.mp4'
          document.body.appendChild(link)
          link.click()

          // 清理
          window.URL.revokeObjectURL(url)
          document.body.removeChild(link)
          loading.close()
        })
        .catch(error => {
          console.error('下载失败:', error)
          loading.close()
          this.$message.error('下载失败，请稍后重试')
        })
    },
    async getOperationStats () {
      const baseParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.data.teacher_id
      }

      try {
        // 获取花数量
        const flowerParams = { ...baseParams }
        flowerParams.sign = sign(flowerParams)
        const flowerRes = await getEduFlowerNum(flowerParams)
        if (flowerRes.data && flowerRes.data.code === 200) {
          this.operationStats.flowerNum = flowerRes.data.data.count || '0'
        }

        // 获取评分
        const averageParams = { ...baseParams }
        averageParams.sign = sign(averageParams)
        const averageRes = await getEduAverageNum(averageParams)
        if (averageRes.data && averageRes.data.code === 200) {
          this.operationStats.averageScore = averageRes.data.data.average || '0'
          this.ratingValue = averageRes.data.data.average || 0
        }

        // 获取收藏数量和状态
        const collectParams = { ...baseParams }
        collectParams.sign = sign(collectParams)
        const collectRes = await getEduCollectNum(collectParams)
        if (collectRes.data && collectRes.data.code === 200) {
          this.operationStats.collectNum = collectRes.data.data.count || '0'
          this.operationStats.isCollected = collectRes.data.data.status === 1
        }

        // 获取点赞数量和状态
        const likeParams = { ...baseParams }
        likeParams.sign = sign(likeParams)
        const likeRes = await getEduLikeNum(likeParams)
        if (likeRes.data && likeRes.data.code === 200) {
          this.operationStats.likeNum = likeRes.data.data.count || '0'
          this.operationStats.isLiked = likeRes.data.data.status === 1
        }
      } catch (error) {
        console.error('获取操作统计数据失败:', error)
      }
    },
    handleLike () {
      const oneParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.data.teacher_id
      }
      const signO = sign(oneParams)
      oneParams.sign = signO

      getEduLike(oneParams).then(res => {
        if (res.data && res.data.code === 200) {
          const status = res.data.data.status
          this.operationStats.isLiked = status === 1
          // 更新所有操作统计数据
          this.getOperationStats()
          this.$message.success(status === 1 ? '点赞成功' : '取消点赞成功')
        } else {
          this.$message.error(res.data.msg || '操作失败')
        }
      }).catch(error => {
        console.error('点赞操作失败:', error)
        this.$message.error('操作失败，请稍后重试')
      })
    },
    handleCollect () {
      const oneParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.data.teacher_id
      }
      const signO = sign(oneParams)
      oneParams.sign = signO

      getEduCollect(oneParams).then(res => {
        if (res.data && res.data.code === 200) {
          const status = res.data.data.status
          this.operationStats.isCollected = status === 1
          // 更新所有操作统计数据
          this.getOperationStats()
          this.$message.success(status === 1 ? '收藏成功' : '取消收藏成功')
        } else {
          this.$message.error(res.data.msg || '操作失败')
        }
      }).catch(error => {
        console.error('收藏操作失败:', error)
        this.$message.error('操作失败，请稍后重试')
      })
    },
    handleShare () {
      this.showShareDialog = true
    },
    handleShareClose () {
      this.showShareDialog = false
    },
    // 分享成功回调
    handleShareSuccess () {
      // 更新教师信息以刷新分享数
      this.getData()
    },
    // 获取礼物列表
    async getGiftList () {
      this.giftLoading = true
      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        page: 1
      }
      const signO = sign(params)
      params.sign = signO

      try {
        const res = await getEduFlowerList(params)
        if (res.data && res.data.message === 'success') {
          const data = res.data.data
          this.giftList = data.row.map(item => {
            return {
              id: item.id,
              name: item.flowername,
              image: item.flowerpic ? this.picUrl + item.flowerpic : '',
              price: item.price
            }
          })

          // 初始化选中和总价
          if (this.giftList.length > 0) {
            this.selectedGift = 0
            this.calculateTotal()
          }
        } else {
          this.$message.error(res.data.msg || '获取礼物列表失败')
        }
      } catch (error) {
        console.error('获取礼物列表失败:', error)
        this.$message.error('获取礼物列表失败，请稍后重试')
      } finally {
        this.giftLoading = false
      }
    },
    // 选择礼物
    selectGift (index) {
      this.selectedGift = index
      this.calculateTotal()
    },
    // 减少数量
    decreaseQuantity () {
      if (this.giftQuantity > 1) {
        this.giftQuantity--
        this.calculateTotal()
      }
    },
    // 增加数量
    increaseQuantity () {
      this.giftQuantity++
      this.calculateTotal()
    },
    // 计算总价
    calculateTotal () {
      if (this.selectedGift !== null && this.giftList[this.selectedGift]) {
        this.totalPrice = (this.giftList[this.selectedGift].price * this.giftQuantity).toFixed(2)
      }
    },
    // 发送礼物
    sendGift () {
      if (this.selectedGift === null) {
        this.$message.warning('请选择礼物')
        return
      }

      if (!this.agreeProtocol) {
        this.$message.warning('请先阅读并同意赠送协议')
        return
      }

      const selectedGift = this.giftList[this.selectedGift]
      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        teacherid: this.data.teacher_id,
        id: selectedGift.id,
        number: this.giftQuantity
      }
      const signO = sign(params)
      params.sign = signO

      const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&')

      sendFlower(queryString).then(res => {
        if (res.data && res.data.code === 200) {
          if (res.data.data && res.data.data.code_url) {
            this.paymentQrCode = res.data.data.code_url
            this.orderNumber = res.data.data.order_number
            this.showPaymentDialog = true
            this.$nextTick(() => {
              this.generateQRCode()
              this.startPaymentStatusCheck()
            })
          } else {
            this.$message.success(`已成功赠送 ${this.giftQuantity} 个${selectedGift.name}给${this.data.name}老师`)
            this.showGiftDialog = false
            this.getData()
          }
        } else {
          this.$message.error(res.data.msg || '赠送失败')
        }
      }).catch(() => {
        this.$message.error('赠送失败，请稍后重试')
      })
    },
    // 生成支付二维码
    generateQRCode () {
      const qrcodeContainer = document.getElementById('payment-qrcode')
      if (qrcodeContainer) {
        qrcodeContainer.innerHTML = ''
        // eslint-disable-next-line no-unused-vars
        const qrcode = new QRCode(qrcodeContainer, {
          width: 200,
          height: 200,
          text: this.paymentQrCode,
          colorDark: '#000',
          colorLight: '#fff',
          correctLevel: QRCode.CorrectLevel.H
        })
      }
    },
    // 开始检查支付状态
    startPaymentStatusCheck () {
      this.clearPaymentTimer()
      this.paymentTimer = setInterval(async () => {
        try {
          const params = {
            appid: this.appid,
            timestamp: parseInt(new Date().getTime() / 1000),
            order_number: this.orderNumber
          }
          const signO = sign(params)
          params.sign = signO

          const res = await updatePayStatus(params)
          if (res.data && res.data.code === 200) {
            const status = res.data.data.trade_state
            if (status === 'SUCCESS') {
              this.$message.success('支付已完成')
              this.clearPaymentTimer()
              this.showPaymentDialog = false
            } else if (status === 'CLOSED') {
              this.$message.warning('订单已关闭')
              this.clearPaymentTimer()
              this.showPaymentDialog = false
            }
          }
        } catch (error) {
          console.error('检查支付状态失败:', error)
        }
      }, 3000)
    },
    // 清除支付状态检查定时器
    clearPaymentTimer () {
      if (this.paymentTimer) {
        clearInterval(this.paymentTimer)
        this.paymentTimer = null
      }
    },
    // 处理支付弹窗关闭
    handlePaymentDialogClose () {
      this.showPaymentConfirm = true
    },
    // 确认关闭支付
    async confirmClosePayment () {
      try {
        const params = {
          appid: this.appid,
          timestamp: parseInt(new Date().getTime() / 1000),
          order_number: this.orderNumber
        }
        const signO = sign(params)
        params.sign = signO

        const res = await updatePayStatus(params)
        if (res.data && res.data.code === 200) {
          const status = res.data.data.trade_state
          switch (status) {
            case 'SUCCESS':
              this.$message.success('支付已完成')
              break
            case 'REFUND':
              this.$message.warning('订单已转入退款')
              break
            case 'NOTPAY':
              this.$message.warning('订单未支付')
              break
            case 'CLOSED':
              this.$message.warning('订单已关闭')
              break
            case 'PAYERROR':
              this.$message.error('支付失败，请稍后重试')
              break
            default:
              this.$message.warning('未知支付状态')
          }
        }
      } catch (error) {
        console.error('获取支付状态失败:', error)
        this.$message.error('获取支付状态失败')
      }
      this.showPaymentConfirm = false
      this.$nextTick(() => {
        this.showPaymentDialog = false
        this.clearPaymentTimer()
      })
    }
  },
  beforeDestroy () {
    this.clearPaymentTimer()
  }
}
</script>

<style lang="less" scoped>
.text-courseware-page {
  background: #fff;
  padding-bottom: 20px;
}
.content-wrapper {
  display: flex;
  margin-top: 20px;
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.left-list {
  flex: 1;
  margin-right: 20px;
}
.right-news {
  width: 320px;
}
.breadcrumb-bar {
  display: flex;
  align-items: center;
  background: #f9f9f9;
  border-radius: 6px;
  padding: 8px 18px;
  margin-bottom: 16px;
  font-size: 14px;
}
.breadcrumb-back {
  border: 1px solid #e5e5e5;
  background: #fff;
  color: #888;
  border-radius: 4px;
  padding: 2px 10px;
  margin-right: 16px;
  height: 28px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s, border 0.2s;
}
.breadcrumb-back:hover {
  background: #f2f2f2;
  border-color: #ccc;
}
.breadcrumb-link {
  color: #666;
}
.breadcrumb-separator {
  color: #ccc;
  margin: 0 4px;
}
.breadcrumb-current {
  color: #ef8432;
  font-weight: bold;
}

/* 课件详情样式 */
.courseware-detail {
  background: #fff;
  border-radius: 6px;
}
.courseware-header {
  margin-bottom: 20px;
  background: url("../../assets/images/title-bg.png") no-repeat center center;
  background-size: cover;
  padding: 20px;
}
.courseware-title {
  font-size: 20px;
  color: #333;
  margin: 0 0 10px;
  font-weight: normal;
}
.courseware-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.meta-stats {
  display: flex;
  color: #888;
  font-size: 14px;
}
.meta-item {
  margin-right: 30px;
  display: flex;
  align-items: center;
}
.meta-item:first-child .count {
  color: #4caf50;
}
.meta-item img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
.meta-actions {
  display: flex;
}
.btn-edit,
.btn-report {
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 13px;
  margin-left: 8px;
  cursor: pointer;
  border: none;
}
.btn-report {
  background: #ff9800;
  color: #fff;
}

/* 内容区域样式 */
.courseware-content {
  margin-bottom: 20px;
}
.courseware-content h2 {
  font-size: 16px;
  margin: 0 0 15px;
  color: #333;
}
.step-list {
  margin: 0;
  color: #666;
  line-height: 1.8;
}
.step-list li {
  margin-bottom: 10px;
}

/* 图片区域 */
.courseware-image {
  margin: 20px 0;
  text-align: center;
}
.courseware-image img {
  max-width: 100%;
}

/* 评论区域 */
.comment-section {
  margin-top: 10px;
}
.comment-input {
  display: flex;
  margin-bottom: 20px;
  background: #f7f7f7;
  padding: 15px;
  border-radius: 4px;
}
.comment-textarea {
  flex: 1;
  height: 60px;
  border: none;
  border-radius: 4px;
  resize: none;
  font-size: 14px;
  background: #f7f7f7;
}
.btn-publish {
  width: 80px;
  margin-left: 10px;
  background: #ef8432;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  height: 32px;
  align-self: flex-end;
}
.comment-list {
  margin-top: 20px;
}
.comment-item {
  display: flex;
  margin-bottom: 20px;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 12px;
}
.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.comment-content {
  flex: 1;
}
.nickname {
  font-weight: bold;
  margin-bottom: 5px;
}
.text {
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
  background: #fdf2ea;
  padding: 10px;
  border-radius: 4px;
}
.comment-time {
  font-size: 12px;
  color: #999;
  display: flex;
  align-items: center;
}
.comment-time img {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}
.time {
  margin-right: 10px;
}
.reply {
  color: #ef8432;
  cursor: pointer;
}

/* 视频播放器样式 */
.video-player {
  position: relative;
  margin-bottom: 20px;
  background: #000;
  overflow: hidden;
  border-radius: 6px;
  width: 100%;
  height: 400px;
  transition: all 0.3s ease;
}
.video-poster {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
  transition: opacity 0.3s ease;
}
.main-video {
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 6px;
  display: block;
  z-index: 2;
}
.video-controls {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  padding: 8px 15px;
  display: flex;
  align-items: center;
  border-radius: 0 0 6px 6px;
  z-index: 3;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.video-player:hover .video-controls {
  opacity: 1;
}
.play-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
  margin-right: 10px;
  padding: 0;
  line-height: 1;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}
.play-btn:hover {
  transform: scale(1.1);
}
.progress-bar {
  flex: 1;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  margin: 0 10px;
  position: relative;
  cursor: pointer;
  transition: height 0.2s ease;
}
.progress-bar:hover {
  height: 6px;
}
.progress-inner {
  height: 100%;
  background: #ef8432;
  border-radius: 2px;
  position: relative;
  transition: background 0.2s ease;
}
.progress-inner:hover {
  background: #ff9800;
}
.time-display {
  color: #fff;
  font-size: 12px;
  margin: 0 10px;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}
.fullscreen-btn {
  background: none;
  border: none;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}
.fullscreen-btn:hover {
  transform: scale(1.1);
}

/* 视频提示信息样式 */
.video-tips {
  color: #666;
  font-size: 14px;
  margin: 15px 0;
  line-height: 1.6;
  padding: 10px;
  background: #f9f9f9;
  border-radius: 4px;
}

/* 视频操作栏样式 */
.video-action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  margin-top: 15px;
}
.action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
.icon-wrapper {
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
  width: 32px;
  height: 32px;
}
.heart-icon {
  color: #ff0000;
}
.gift-item {
  position: relative;
}
.gift-icon {
  color: #ff5722;
}
.action-item span {
  color: #666;
  font-size: 12px;
}
.operation-section {
  padding: 12px 16px;
  background: #f8f8f8;
  border: none;
  border-radius: 6px;
  margin: 20px 0;

  .operation-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;

    .operation-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 4px;
      cursor: pointer;
      padding: 6px 12px;
      border-radius: 4px;
      transition: all 0.2s ease;

      &:hover {
        background: rgba(239, 132, 50, 0.1);
      }

      .operation-icon {
        width: 16px;
        height: 16px;
        transition: transform 0.2s ease;
      }

      .operation-text {
        font-size: 13px;
        color: #666666;
        font-weight: normal;
      }

      .operation-count {
        font-size: 13px;
        color: #666666;
        margin-left: 4px;
      }

      &.active {
        background: rgba(239, 132, 50, 0.1);

        .operation-text {
          color: #ef8432;
        }
        .operation-count {
          color: #ef8432;
        }
      }

      &:hover {
        .operation-icon {
          transform: scale(1.1);
        }
        .operation-text,
        .operation-count {
          color: #ef8432;
        }
      }
    }
  }
}

/* 回复区域样式 */
.reply-section {
  margin-top: 12px;
  padding: 12px;
  background: #f9f9f9;
  border-radius: 4px;
}
.reply-input {
  display: flex;
  gap: 10px;
}
.reply-textarea {
  flex: 1;
  height: 40px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding: 8px;
  resize: none;
  font-size: 14px;
  background: #fff;
}
.btn-reply {
  width: 60px;
  background: #ef8432;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  height: 40px;
  align-self: flex-end;
}
.reply-list {
  margin-top: 12px;
}
.reply-item {
  display: flex;
  margin-bottom: 12px;
  padding: 8px;
  background: #f9f9f9;
  border-radius: 4px;
}
.reply-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 8px;
}
.reply-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.reply-content {
  flex: 1;
}
.reply-nickname {
  font-weight: bold;
  font-size: 13px;
  margin-bottom: 4px;
}
.reply-text {
  color: #666;
  font-size: 13px;
  line-height: 1.4;
  margin-bottom: 4px;
}
.reply-time {
  font-size: 12px;
  color: #999;
  display: flex;
  align-items: center;
}
.reply-time img {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}

/* 评论区域样式增强 */
.comment-section {
  margin-top: 20px;
  background: #fff;
  border-radius: 6px;
  padding: 20px;
}
.comment-input {
  display: flex;
  margin-bottom: 20px;
  background: #f7f7f7;
  padding: 15px;
  border-radius: 4px;
  gap: 10px;
}
.comment-textarea {
  flex: 1;
  height: 60px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  resize: none;
  font-size: 14px;
  padding: 8px;
  background: #fff;
  transition: border-color 0.2s ease;
}
.comment-textarea:focus {
  border-color: #ef8432;
  outline: none;
}
.btn-publish {
  width: 80px;
  background: #ef8432;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  height: 32px;
  align-self: flex-end;
  transition: background 0.2s ease;
}
.btn-publish:hover {
  background: #ff9800;
}
.comment-list {
  margin-top: 20px;
}
.comment-item {
  display: flex;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;
}
.comment-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 12px;
  border: 2px solid #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.comment-content {
  flex: 1;
}
.nickname {
  font-weight: bold;
  margin-bottom: 5px;
  color: #333;
}
.text {
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
  background: #fdf2ea;
  padding: 10px;
  border-radius: 4px;
}
.comment-time {
  font-size: 12px;
  color: #999;
  display: flex;
  align-items: center;
}
.comment-time img {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}
.time {
  margin-right: 10px;
}
.reply {
  color: #ef8432;
  cursor: pointer;
  transition: color 0.2s ease;
}
.reply:hover {
  color: #ff9800;
}
.pagination-bar {
  margin-top: 20px;
  text-align: center;
}

/* 送礼物弹窗样式 */
.gift-dialog {
  .el-dialog__header {
    padding: 10px;
  }

  .el-dialog__body {
    padding: 0;
  }

  .gift-dialog-content {
    display: flex;
    min-height: 400px;

    .dialog-left {
      width: 160px;
      border-right: 1px solid #EBEEF5;
      padding: 20px;
      display: flex;
      align-items: center;
      flex-direction: column;

      .teacher-profile {
        text-align: center;

        .teacher-avatar {
          width: 130px;
          height: 130px;
          border-radius: 10px;
          margin-bottom: 16px;
          object-fit: cover;
        }

        .teacher-name {
          font-size: 14px;
          color: #333;
          margin-bottom: 8px;
          font-weight: 500;
        }

        .teacher-title {
          font-size: 12px;
          color: #666;
          margin-bottom: 4px;
          text-align: center;
        }

        .teacher-location {
          font-size: 12px;
          color: #999;
          margin-bottom: 4px;
        }

        .teacher-rating {
          font-size: 12px;
          color: #666;

          .rating-label {
            color: #999;
          }

          .rating-value {
            color: #EF8432;
          }
        }
      }
    }

    .dialog-right {
      flex: 1;
      padding: 20px;

      .gift-list {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 12px;
        max-height: 360px;
        overflow-y: auto;

        .gift-item {
          text-align: center;
          background-color: #F8F8F8;
          border: 1px solid #EBEEF5;
          border-radius: 4px;
          padding: 8px;
          cursor: pointer;
          transition: all 0.3s;

          &:hover {
            border-color: #EF8432;
          }

          &.active {
            border-color: #EF8432;
            box-shadow: 0 0 5px rgba(239, 132, 50, 0.5);
          }

          .gift-image {
            width: 60px;
            height: 60px;
            margin-bottom: 5px;
          }

          .gift-name {
            font-size: 12px;
            color: #3D3D3D;
            margin-bottom: 2px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .gift-price {
            font-size: 14px;
            color: #E4004E;
          }
        }
      }

      .loading-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 0;

        .loading-spinner {
          width: 40px;
          height: 40px;
          border: 3px solid #f3f3f3;
          border-radius: 50%;
          border-top: 3px solid #EF8432;
          animation: spin 1s linear infinite;
          margin-bottom: 10px;
        }

        p {
          color: #666;
          font-size: 14px;
        }
      }

      .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 0;

        .empty-icon {
          width: 100px;
          height: 100px;
          margin-bottom: 16px;
        }

        .empty-text {
          color: #999;
          font-size: 14px;
        }
      }
    }
  }

  .gift-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-top: 1px solid #EBEEF5;

    .footer-left {
      .protocol-link {
        color: #EF8432;
        text-decoration: none;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .footer-center {
      display: flex;
      align-items: center;
      gap: 20px;

      .quantity-control {
        display: flex;
        align-items: center;
        gap: 8px;

        .quantity-label {
          color: #666;
          font-size: 14px;
        }

        .quantity-btn {
          width: 24px;
          height: 24px;
          border: 1px solid #DCDFE6;
          background: #fff;
          border-radius: 4px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          color: #606266;

          &:hover {
            color: #EF8432;
            border-color: #EF8432;
          }
        }

        .quantity-input {
          width: 40px;
          height: 24px;
          border: 1px solid #DCDFE6;
          border-radius: 4px;
          text-align: center;
          font-size: 14px;
          color: #606266;
        }
      }

      .total-price {
        font-size: 14px;
        color: #666;

        .price-value {
          color: #E4004E;
          font-size: 18px;
          font-weight: 500;
        }
      }
    }
  }
}

/* 支付弹窗样式 */
.payment-dialog {
  .payment-content {
    padding: 20px;
    text-align: center;

    .payment-title {
      font-size: 16px;
      color: #333;
      margin-bottom: 20px;
    }

    .qrcode-container {
      width: 200px;
      height: 200px;
      margin: 0 auto 20px;
      padding: 10px;
      border: 1px solid #EBEEF5;
      border-radius: 4px;
    }

    .payment-tip {
      color: #666;
      font-size: 14px;
      margin-bottom: 20px;
    }
  }
}

/* 支付确认弹窗样式 */
.payment-confirm-dialog {
  .confirm-content {
    padding: 20px;
    text-align: center;

    p {
      font-size: 16px;
      color: #333;
      margin-bottom: 10px;
    }

    .confirm-tip {
      font-size: 14px;
      color: #666;
    }
  }

  .dialog-footer {
    text-align: center;
    padding-bottom: 20px;
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/VideoCoursewareDetail.vue